// PingingVideo.jsx
import PingingDataTable from "../../components/PingingDataTable/PingingDataTable";
const PingingVideo = () => {
  return (
    <PingingDataTable
      title="Pinging Report - Lesson Pages"
      apiEndpoint="/pinging-page"
      defaultValue="video_all"
      showVideoColumns={true}
      showPlayVideo={true}
      type="ping"
      pingType="video"
      toolId={4}
    />
  );
};

export default PingingVideo;
